import { PageComponent, isTriggerBack } from "barba"

class IsWithinClass {

    constructor({ node }) {
        this.node = node
        this.img = null

        this.initHandler = this.init.bind(this)
        this.loadedHandler = this.loaded.bind(this)

        window.requestAnimationFrame(this.initHandler)
    }

    init() {
        const bgImgUrl = window.getComputedStyle(this.node).getPropertyValue("background-image")

        if (!bgImgUrl.toLowerCase().startsWith("url(")) {
            this.loaded()
            return
        }

        let url = bgImgUrl.replace(/^url\("?|"?\)$/ig, '')
        this.img = new Image()
        this.img.src = url

        if (this.img.complete) {
            this.loaded()
            return
        }

        this.img.addEventListener('load', this.loadedHandler)
    }

    loaded() {
        let classes = this.node.dataset.bgImgLoadedClass
        classes = classes.replace(/\s+/g, " ")
        classes = classes.split(" ")

        classes.push(isTriggerBack() ? 'is-back' : 'is-foward')
        
        this.node.classList.add(...classes)
        
        this.img && this.img.removeEventListener('load', this.loadedHandler)
        this.img = null
    }

    destroy() {
        !this.img || this.img.removeEventListener('load', this.loadedHandler)
        
        delete this.node
        delete this.img

        delete this.initHandler
        delete this.loadedHandler
    }

}

new PageComponent("[data-bg-img-loaded-class]", IsWithinClass)